export default __webpack_public_path__ + "static/media/screen1.2006ed1a.png";